import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useGetCustomerQuery, useGetUserPreferencesQuery } from '@/api/v1';
import { configuration } from '@/config';
import { TimezoneContext } from '@/hooks/useDateFormatter';
import { useLogout } from '@/hooks/useLogout';
import { defaultLocale, LocaleContext } from '@/hooks/useTranslator';
import { Dashboard } from '@/Screens/Dashboard';
import { VerifyBusiness } from '@/Screens/VerifyBusiness';
import { Locale } from '@/types/locale';

const PrivateRoutes: React.FC = (): React.ReactElement => {
  const { isError } = useGetCustomerQuery();
  const { data: preferences } = useGetUserPreferencesQuery();

  const language = React.useMemo(
    (): Locale => preferences?.language ?? defaultLocale,
    [preferences],
  );

  const timezone = React.useMemo(
    (): string => preferences?.timezone ?? configuration.defaultTimezone,
    [preferences],
  );

  const logout = useLogout();

  if (isError) {
    logout();

    return <></>;
  }

  return (
    <LocaleContext.Provider value={language}>
      <TimezoneContext.Provider value={timezone}>
        <Routes>
          <Route path="/verify-business/*" element={<VerifyBusiness />} />
          <Route path="/*" element={<Dashboard />} />
          <Route path="/logout" element={<Navigate to="/" replace={true} />} />

          <Route path="*" element={<Navigate to="/dashboard" replace={true} />} />
        </Routes>
      </TimezoneContext.Provider>
    </LocaleContext.Provider>
  );
};

export default PrivateRoutes;
